<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 안전·보건 교육 및 점검</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer">
        <div>
          <div>점검일</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_1 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputA_1" />
        </div>
        <div>
          <div>점검장소</div>
          <ml-input v-model="form.inputA_2" :readonly="board.readonly" />
        </div>
        <div>
          <div>점검자</div>
          <ml-input v-model="form.inputA_3" :readonly="board.readonly" />
        </div>
        <div>
          <div>교육시간</div>
          <div class="flex" style="align-items: center; ">
            <ml-input v-model="form.inputA_4" :readonly="board.readonly" />
            <p class="mx-2" style="width: 60px;">시간</p>
            <ml-input v-model="form.inputA_5" :readonly="board.readonly" />
            <p class="ml-2">분</p>
          </div>
        </div>
        <div>
          <div>참석자 수</div>
          <ml-input v-model="form.inputA_6" :readonly="board.readonly" type="number"/>
        </div>
        <div class="writeGridLineItem">
          <div>교육내용</div>
          <ml-textarea rows="5" v-model="form.inputA_7" :readonly="board.readonly"
                       placeholder="※ 작업전 10분교육을 정기안전교육으로 인정받기위해서는 반드시 실제로 실시해야하며 관리감독자가 교육하고 근로자 서명부, 사진, 교육자료가 첨부되어야함"/>
        </div>
      </div>
    </div>

    <vs-row class="mt-6 mb-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 교육 및 점검대상</h5>
      </vs-col>
    </vs-row>
    <div class="writeGridContainer">
      <div class="col-span-2 flex items-center"
           v-for="checkbox in form.inspectList"
           v-bind:key="checkbox.id"
      >
        <div v-if="isPrint || board.readonly" class="flex w-full">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex w-full">
          <vs-checkbox
            :readonly="board.readonly"
            v-model="checkbox.check"
            @change="checkForm">
          </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <!--    TBM 점검표-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="'TBM 점검표'"
      :list="form.inspectListDefault"
      table-header-note="비고"
      @update-list-check="updateListDefaultCheck"
    />

    <div
      v-for="(inspection, indexRows) in form.inspectList"
      v-bind:key="inspection.id"
    >
      <table-inspect
        class="mt-5"
        v-bind:key="inspection.id"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="true"
        :isNote="true"
        :title="inspection.title"
        :list="inspection.list"
        table-header-title="안전검사 주기"
        table-header-note="비고"
        @update-list-check="(param1, param2)=>{
        updateListCheck(indexRows,param1,param2
        )}"
        v-if="inspection.check"
      />
    </div>

<!--    확인자-->
    <div>
      <h5 class="mt-6"><i class="dot"></i>확인자</h5>
      <div class="writeGridContainer mt-6">
        <div>
          <div class="title">현장소장</div>
          <div>
            <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_1 }}</p>
            <ml-input v-else class="w-full" v-model="form.inputC_1" :readonly="board.readonly" />
          </div>
        </div>
        <div>
          <div class="title">서명</div>
          <div>
            <SignField class="w-full" v-model="form.inputC_2" :readonly="board.readonly" />
          </div>
        </div>
      </div>
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="점검 현장 사진"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector.vue";
import TableInspect from "@/components/TableInspect.vue";
import SignField from "@/components/SignField.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";

export default {
  components: {
    PhotoUploadGridModule,
    SignField,
    TableInspect,
    DateSelector,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  methods: {
    updateListDefaultCheck(indexRows, text) {
      this.form.inspectListDefault[indexRows].is_checked = text;
    },
    updateListCheck (indexList, indexTableRows, text) {
      this.form.inspectList[indexList].list[indexTableRows].is_checked = text
    },
    checkForm () {
      this.form.typeTitleList = []
      for (const data of this.form.inspectList) {
        if (data.check) {
          this.form.typeTitleList.push(data.label)
        }
      }
    },
  },
  data() {
    return {
      form: {
        inputA_1: '',
        inputA_2: '',
        inputA_3: '',
        inputA_4: '',
        inputA_5: '',
        inputA_6: '',
        inputA_7: '',

        inputC_1: '',
        inputC_2: '',

        stdInfo: {},
        fileList: [],
        photoList: [],

        typeTitleList: [],
        inspectListDefault: [
          {
            id: 1,
            label: "해당 작업의 위험성평가를 실시하였다.(해당 작업의 위험성평가 결과가 있다.)",
            is_checked: "",
            title: "TBM 사전준비",
            note: ''
          },
          {
            id: 2,
            label: "해당 작업에서 발생한 사고보고서(아차사고 포함)의 내용을 확인하였다.",
            is_checked: "",
            title: "TBM 사전준비",
            note: ''
          },
          {
            id: 3,
            label: "작업 물량과 범위, 작업내용과 필요한 보호구를 잘 알고 있다.",
            is_checked: "",
            title: "TBM 사전준비",
            note: ''
          },
          {
            id: 4,
            label: "위험성평가 결과, 사고보고서, 안전작업 지침의 내용을 여러 번 읽어 숙지하였다.",
            is_checked: "",
            title: "TBM 사전준비",
            note: ''
          },
          {
            id: 5,
            label: "작업자가 음주, 발열, 약물 복용 등으로 작업에 적합한지 여부를 확인하였다.",
            is_checked: "",
            title: "TBM 실행과정",
            note: ''
          },
          {
            id: 6,
            label: "작업내용 / 위험요인 / 안전 작업절차 / 대책에 대해 긍정적인 분위기로 대화하였다.",
            is_checked: "",
            title: "TBM 실행과정",
            note: ''
          },
          {
            id: 7,
            label: "작업자와 중점 위험요인과 대책을 도출하고 이를 숙지하도록 하였다.",
            is_checked: "",
            title: "TBM 실행과정",
            note: ''
          },
          {
            id: 8,
            label: "작업 후 정리정돈 상태를 확인하였다.",
            is_checked: "",
            title: "TBM 실행과정",
            note: ''
          },
          {
            id: 9,
            label: "작업자가 제기한 불만사항, 질문, 제안사항을 검토하였다.",
            is_checked: "",
            title: "TBM 후속조치",
            note: ''
          },
          {
            id: 10,
            label: "TBM 결과를 충실하게 기록하고 보관한다.",
            is_checked: "",
            title: "TBM 후속조치",
            note: ''
          },
          {
            id: 11,
            label: "관련 조치결과는 작업자에게 피드백 한다.",
            is_checked: "",
            title: "TBM 후속조치",
            note: ''
          },
        ],
        inspectList: [
          {
            id: 1,
            label: '도로보수원(건설장비 및 차량운전포함)',
            check: false,
            title: '도로보수원(건설장비 및 차량운전포함)',
            list: [
              {
                id: 1,
                label: "필요한 보호구(안전모, 안전화, 형광조끼, 마스크)를 착용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 2,
                label: "작업구역의 넘어짐, 떨어짐, 부딪힘 등 위험장소를 인지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 3,
                label: "작업 시 유해·위험요인 및 작업 방법을 잘 숙지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 4,
                label: "용도에 맞는 작업도구를 선택하고 사용 전 점검하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 5,
                label: "장비·자재 상차 및 하차 시 안전사고에 주의하여 작업하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 6,
                label: "작업현장 후방 작업보호자동차(싸인-보트카)를 배치하였는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 7,
                label: "교통사고 방지를 위해 작업장소 전방에 신호수 배치 및 안내표지판 설치하고 단속을 실시하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 8,
                label: "1개조 인원은 3인 이상으로 하여 작업 하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 9,
                label: "작업장비가 작동하는 반경 내 작업자 출입금지를 준수하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 10,
                label: "작업 시작 전 차량 안전점검을 우선 실시하고 차량 내 정리 정돈을 실시하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 11,
                label: "운행전 타이어 공기압, 경광등 작동, 차량 전조등 점등 여부 등 차량 점검을 실시하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 12,
                label: "차량 운행 중 화재 발생 대비 차량 내 분말소화기 배치하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 13,
                label: "차량에 장착된 경광등 및 앰프가 정상적으로 작동하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 14,
                label: "교통사고 방지를 위해 작업장소 전방에 신호수 배치 및 안내표지판 설치하고 단속을 실시하는가",
                is_checked: "",
                note: ''
              },
              {
                id: 15,
                label: "교통사고 방지를 위해 작업장소 전방에 신호수 배치 및 안내표지판 설치하고 작업을 실시하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 16,
                label: "보행중 · 작업 중 휴대전화 사용 금지를 이행하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 17,
                label: "작업전후, 작업중 스트레칭 실시 하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 18,
                label: "중량물(25kg이상)취급시 2인1조 작업을 시행하고 있는가?",
                is_checked: "",
                note: ''
              },
            ],
          },
          {
            id: 2,
            label: '환경분야 근로자(차량운전포함)',
            check: false,
            title: '환경분야 근로자(차량운전포함)',
            list: [
              {
                id: 1,
                label: "필요한 보호구(안전화, 안전모, 안전장갑 등)를 지급ㆍ착용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 2,
                label: "작업구역의 넘어짐, 떨어짐 등 위험장소를 인지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 3,
                label: "작업 시 유해·위험요인 및 작업 방법을 잘 숙지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 4,
                label: "용도에 맞는 작업도구를 선택하고 사용 전 점검하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 5,
                label: "예초기 사용 시 방호덮개가 설치된 예초기를 사용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 6,
                label: "기계톱 사용 시 안전장치(체인브레이크, 보호가드 등)가 설치된 기계톱을 사용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 7,
                label: "전지 작업 시 도구를 휴대할 수 있는 벨트·가방을 착용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 8,
                label: "비료나 농약 취급 시 바람을 등지고 보호구(방진마스크, 보안경 등)를 착용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 9,
                label: "2m이상 고소작업시 안전난간대,발판,설치.안전대 착용등 떨어짐 예방 조치를 하였는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 10,
                label: "사다리 작업 시 안전한 작업 방법(안전대 착용, 2인 1조 작업, 전도방지용 안전지지대 설치 등)을 숙지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 11,
                label: "중량물 취급 시 2인 1조 작업하거나 이동대차를 사용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 12,
                label: "주기적으로 스트레칭을 실시하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 13,
                label: "작업 시작 전 차량 안전점검을 우선 실시하고 차량 내 정리 정돈을 실시하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 14,
                label: "운행전 타이어 공기압, 경광등 작동, 차량 전조등 점등 여부 등 차량 점검을 실시하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 15,
                label: "차량 운행 중 화재 발생 대비 차량 내 분말소화기 배치하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 16,
                label: "차량에 장착된 경광등 및 앰프가 정상적으로 작동하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 17,
                label: "교통사고 방지를 위해 작업장소 전방에 신호수 배치 및 안내표지판 설치하고 단속을 실시하는가",
                is_checked: "",
                note: ''
              },
              {
                id: 18,
                label: "보행중 · 작업 중 휴대전화 사용 금지를 이행하고 있는가?",
                is_checked: "",
                note: ''
              },
            ],
          },
          {
            id: 3,
            label: '녹지분야 근로자(차량운전포함)',
            check: false,
            title: '녹지분야 근로자(차량운전포함)',
            list: [
              {
                id: 1,
                label: "필요한 보호구(안전화, 안전모, 안전장갑 등)를 지급ㆍ착용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 2,
                label: "작업구역의 넘어짐, 떨어짐 등 위험장소를 인지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 3,
                label: "작업 시 유해·위험요인 및 작업 방법을 잘 숙지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 4,
                label: "연료 용기 주변에 화기를 금하고 소화기는 비치 되었는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 5,
                label: "예초기 사용 시 방호덮개가 설치된 예초기를 사용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 6,
                label: "기계톱 사용 시 안전장치(체인브레이크, 보호가드 등)가 설치된 기계톱을 사용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 7,
                label: "전지 작업 시 도구를 휴대할 수 있는 벨트·가방을 착용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 8,
                label: "유해물질사용 시 작업전 교육을 실시하였는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 9,
                label: "2m이상 고소작업시 안전난간대,발판,설치.안전대 착용등 떨어짐 예방 조치를 하였는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 10,
                label: "사다리 작업 시 안전한 작업 방법(안전대 착용, 2인 1조 작업, 전도방지용 안전지지대 설치 등)을 숙지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 11,
                label: "중량물 취급 시 2인 1조 작업하거나 이동대차를 사용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 12,
                label: "주기적으로 스트레칭을 실시하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 13,
                label: "작업 시작 전 차량 안전점검을 우선 실시하고 차량 내 정리 정돈을 실시하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 14,
                label: "운행전 타이어 공기압, 경광등 작동, 차량 전조등 점등 여부 등 차량 점검을 실시하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 15,
                label: "차량 운행 중 화재 발생 대비 차량 내 분말소화기 배치하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 16,
                label: "차량에 장착된 경광등 및 앰프가 정상적으로 작동하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 17,
                label: "교통사고 방지를 위해 작업장소 전방에 신호수 배치 및 안내표지판 설치하고 단속을 실시하는가",
                is_checked: "",
                note: ''
              },
              {
                id: 18,
                label: "보행중 · 작업 중 휴대전화 사용 금지를 이행하고 있는가?",
                is_checked: "",
                note: ''
              },
            ],
          },
          {
            id: 4,
            label: '예초작업',
            check: false,
            title: '예초작업',
            list: [
              {
                id: 1,
                label: "작업자에게 안전모, 보안면, 보안경, 방진장갑, 귀 마개 등 작업에 적절한 보호구를 지급･착용토록 하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 2,
                label: "작업구역의 넘어짐, 떨어짐, 부딪힘 등 위험장소를 인지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 3,
                label: "작업 시 유해·위험요인 및 작업 방법을 잘 숙지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 4,
                label: "용도에 맞는 작업도구를 선택하고 사용 전 점검하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 5,
                label: "예초기 사용 시 방호덮개가 설치된 예초기를 사용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 6,
                label: "예초기 작업 중 예초기 날이 돌 또는 굻은 나무 등에 부딪치지 않도록 주의하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 7,
                label: "돌 등에 부딪힌 경우에는 엔진을 정지시키고 톱날의 이상 유무를 확인 하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 8,
                label: "예초기를 들고 작업장 이동 시 안전거리(10㎝ 이상) 내에는 다른 작업자의 접근을 금지하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 9,
                label: "작업 반경(10m 이상) 내에서 다른 작업자의 접근을 금지하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 10,
                label: "톱날이 넝쿨에 휘감기지 않도록 주의하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 11,
                label: "넝쿨 위 부분을 1차로 작업한 후 아래 부분을 작업하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 12,
                label: "연료 용기 주변에 화기를 금하고 소화기는 비치 되었는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 13,
                label: "경사 방향으로 작업을 진행하고 급경사지에서는 작업을 금지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 14,
                label: "주기적 스트레칭을 하는가",
                is_checked: "",
                note: ''
              },
              {
                id: 15,
                label: "보행중 · 작업 중 휴대전화 사용 금지를 이행하고 있는가?",
                is_checked: "",
                note: ''
              },
            ],
          },
          {
            id: 5,
            label: '엔진톱 작업',
            check: false,
            title: '엔진톱 작업',
            list: [
              {
                id: 1,
                label: "작업자에게 안전모, 보안경, 방진장갑,귀마개 등 작업에 적절한 보호구를 지급･착용토록 하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 2,
                label: "작업구역의 넘어짐, 떨어짐, 부딪힘 등 위험장소를 인지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 3,
                label: "작업 시 유해·위험요인 및 작업 방법을 잘 숙지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 4,
                label: "용도에 맞는 작업도구를 선택하고 사용 전 점검하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 5,
                label: "기계톱 사용 전에 볼트･너트 체결상태, 톱날, 방호장치* 상태, 누유 여부 등을 확인한 후 작업을 시작하는가?\n* 전방 방호판, 체인 브레이크 조작판, 체인잡이, 진동방지장치 등",
                is_checked: "",
                note: ''
              },
              {
                id: 6,
                label: "기계톱 시동 전 주변에 근로자와 연료, 장애물이 없는지 확인하고, 지면에서 기계톱을 작동하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 7,
                label: "킥백(Kick Back)현상*을 방지하기 위해 기계톱 톱날 회전 방향에 맞는 절단 방법을 준수하여 작업하는가?\n* 회전하는 톱체인(가이드바) 끝의 상단부분이 어떤 물체에 닿아서 체인톱이 작업자 쪽으로 튀는 현상",
                is_checked: "",
                note: ''
              },
              {
                id: 8,
                label: "연료 용기는 연료누출이 없고, 위험물질 경고표지를 부착하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 9,
                label: "연료 용기 주변에 화기를 금하고 소화기는 비치 되었는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 10,
                label: "기계톱 작업 시 섬유조직이 톱날의 회전을 멈추게 할 수 있는 안전바지 및 무릎보호대를 착용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 11,
                label: "다른 지점으로 이동하거나, 톱을 사용하지 않을 때는 체인톱날이 돌지 않게 체인 브레이크를 사용하고, 먼 거리 이동 시 엔진을 정지하고 안전덮개를 부착하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 12,
                label: "기계톱의 정비･청소･급유 등을 할 때 반드시 기계톱의 운전을 정지한 후에 작업을 실시하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 13,
                label: "작업 전 작업자 및 신호수가 작업구역, 작업 순서 및 방법, 신호체계 등을 숙지하였는지 확인한 후 작업을 시작하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 14,
                label: "기계톱에 설치된 방호장치를 임의로 해체하거나 기능을 정지하지 않는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 15,
                label: "2m이상 고소작업시 안전난간대,발판,설치.안전대 착용등 떨어짐 예방 조치를 하였는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 16,
                label: "보행중 · 작업 중 휴대전화 사용 금지를 이행하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 17,
                label: "작업전후, 작업중 스트레칭 실시 하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 18,
                label: "중량물(25kg이상)취급시 2인1조 작업을 시행하고 있는가?",
                is_checked: "",
                note: ''
              },
            ],
          },
          {
            id: 6,
            label: '건설장비 및 차량운전자',
            check: false,
            title: '건설장비 및 차량운전자',
            list: [
              {
                id: 1,
                label: "필요한 보호구(형광조끼, 마스크)를 착용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 2,
                label: "작업구역의 넘어짐, 떨어짐, 부딪힘 등 위험장소를 인지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 3,
                label: "작업 시 유해·위험요인 및 작업 방법을 잘 숙지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 4,
                label: "용도에 맞는 작업도구를 선택하고 사용 전 점검하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 5,
                label: "작업 시작 전 차량 안전점검을 우선 실시하고 차량 내 정리 정돈을 실시하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 6,
                label: "운행전 타이어 공기압, 경광등 작동, 차량 전조등 점등 여부 등 차량 점검을 실시하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 7,
                label: "차량 운행 중 화재 발생 대비 차량 내 분말소화기 배치하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 8,
                label: "차량에 장착된 경광등 및 앰프가 정상적으로 작동하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 9,
                label: "교통사고 방지를 위해 작업장소 전방에 신호수 배치 및 안내표지판 설치하고 단속을 실시하는가",
                is_checked: "",
                note: ''
              },
              {
                id: 10,
                label: "교통사고 방지를 위해 작업장소 전방에 신호수 배치 및 안내표지판 설치하고 작업을 실시하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 11,
                label: "보행중 · 작업 중 휴대전화 사용 금지를 이행하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 12,
                label: "작업전후, 작업중 스트레칭 실시 하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 13,
                label: "중량물(25kg이상)취급시 2인1조 작업을 시행하고 있는가?",
                is_checked: "",
                note: ''
              },
            ],
          },
          {
            id: 7,
            label: '시설정비원(기계)',
            check: false,
            title: '시설정비원(기계)',
            list: [
              {
                id: 1,
                label: "필요한 보호구(안전화, 안전모, 안전장갑 등)를 지급ㆍ착용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 2,
                label: "작업구역의 넘어짐, 떨어짐, 부딪힘 등 위험장소를 인지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 3,
                label: "작업 시 유해·위험요인 및 작업 방법을 잘 숙지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 4,
                label: "용도에 맞는 작업도구를 선택하고 사용 전 점검하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 5,
                label: "휴대용연삭기(핸드그라인더) 사용 시 방호덮개가 설치된 휴대용연삭기을 사용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 6,
                label: "점검·보수 시 주전원을 차단하고 잠금장치 및 표지판을 설치한 후 작업하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 7,
                label: "2m이상 고소작업시 안전난간대,발판,설치.안전대 착용등 떨어짐 예방 조치를 하였는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 8,
                label: "사다리 작업 시 안전한 작업 방법(안전대 착용, 2인 1조 작업, 전도방지용 안전지지대 설치 등)을 숙지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 9,
                label: "중량물 취급 시 2인 1조 작업하거나 이동대차를 사용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 10,
                label: "주기적으로 스트레칭을 실시하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 11,
                label: "보행중 · 작업 중 휴대전화 사용 금지를 이행하고 있는가?",
                is_checked: "",
                note: ''
              },
            ],
          },
          {
            id: 8,
            label: '시설정비원(전기)',
            check: false,
            title: '시설정비원(전기)',
            list: [
              {
                id: 1,
                label: "필요한 절연용 보호구(안전화, 안전모, 절연장갑 등)를 지급ㆍ착용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 2,
                label: "작업구역의 감전, 넘어짐, 떨어짐 등 위험장소를 인지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 3,
                label: "작업 시 유해·위험요인 및 작업 방법을 잘 숙지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 4,
                label: "용도에 맞는 작업도구를 선택하고 사용 전 점검하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 5,
                label: "감전방지용 누전차단기, 접지설치 및 정상 작동되고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 6,
                label: "전선연결부, 피복 손상 등 절연상태가 양호한가?",
                is_checked: "",
                note: ''
              },
              {
                id: 7,
                label: "전기기계·기구 및 설비의 외함에 접지시설이 되어 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 8,
                label: "휴대용 또는 이동형 전기기계·기구 전원에 누전차단기(또는 이중절연구조)설치되어 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 9,
                label: "점검·보수 시 주전원을 차단하고 잠금장치 및 표지판을 설치한 후 작업하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 10,
                label: "2m이상 고소작업시 안전난간대,발판,설치.안전대 착용등 떨어짐 예방 조치를 하였는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 11,
                label: "사다리 작업 시 안전한 작업 방법(안전대 착용, 2인 1조 작업, 전도방지용 안전지지대 설치 등)을 숙지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 12,
                label: "중량물 취급 시 2인 1조 작업하거나 이동대차를 사용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 13,
                label: "주기적으로 스트레칭을 실시하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 14,
                label: "보행중 · 작업 중 휴대전화 사용 금지를 이행하고 있는가?",
                is_checked: "",
                note: ''
              },
            ],
          },
          {
            id: 9,
            label: '시설청소원',
            check: false,
            title: '시설청소원',
            list: [
              {
                id: 1,
                label: "필요한 보호구(미끄럼방지 장화, 보호장갑, 보안경 등)를 지급ㆍ착용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 2,
                label: "작업구역의 넘어짐, 떨어짐 등 위험장소를 인지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 3,
                label: "작업 시 유해·위험요인 및 작업 방법을 잘 숙지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 4,
                label: "용도에 맞는 작업도구를 선택하고 사용 전 점검하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 5,
                label: "바닥 청소 시 청소도구(마포걸레 등)의 물기는 최대한 제거하고, 미끄럼주의 표지판을 설치하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 6,
                label: "청소용구 등 운반물 이동 시 전용대차를 사용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 7,
                label: "전기기계·기구 사용 시 방수형 콘센트를 사용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 8,
                label: "락스 등 유해·화학물질 사용 시 보호구(보안경, 보호장갑 등)을 착용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 9,
                label: "2m이상 고소작업시 안전난간대,발판,설치.안전대 착용등 떨어짐 예방 조치를 하였는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 10,
                label: "사다리 작업 시 안전한 작업 방법(안전대 착용, 2인 1조 작업, 전도방지용 안전지지대 설치 등)을 숙지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 11,
                label: "중량물 취급 시 2인 1조 작업하거나 이동대차를 사용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 12,
                label: "주기적으로 스트레칭을 실시하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 13,
                label: "보행중 · 작업 중 휴대전화 사용 금지를 이행하고 있는가?",
                is_checked: "",
                note: ''
              },
            ],
          },
          {
            id: 10,
            label: '시설경비원',
            check: false,
            title: '시설경비원',
            list: [
              {
                id: 1,
                label: "필요한 안전장비(손전등, 경광봉, 야광조끼, 무전기 등)를 지급ㆍ착용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 2,
                label: "작업구역의 넘어짐, 떨어짐 등 위험장소를 인지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 3,
                label: "작업 시 유해·위험요인 및 순찰 통로를 잘 숙지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 4,
                label: "야간작업 시 주기적으로 휴식 등을 취하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 5,
                label: "비 또는 눈이 오는 날 출입구에 물기제거매트 등을 설치하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 6,
                label: "자전거 등을 타고 순찰 시 승차용 안전모를 착용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 7,
                label: "사다리 작업 시 안전한 작업 방법(안전대 착용, 2인 1조 작업, 전도방지용 안전지지대 설치 등)을 숙지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 8,
                label: "주기적으로 스트레칭을 실시하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 9,
                label: "보행중 · 작업 중 휴대전화 사용 금지를 이행하고 있는가?",
                is_checked: "",
                note: ''
              },
            ],
          },
          {
            id: 11,
            label: '승강기 정비·청소원',
            check: false,
            title: '승강기 정비·청소원',
            list: [
              {
                id: 1,
                label: "필요한 보호구(미끄럼방지 장화, 보호장갑, 보안경 등)를 지급ㆍ착용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 2,
                label: "작업구역의 넘어짐, 떨어짐 등 위험장소를 인지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 3,
                label: "작업 시 유해·위험요인 및 작업 방법을 잘 숙지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 4,
                label: "용도에 맞는 작업도구를 선택하고 사용 전 점검하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 5,
                label: "바닥 청소 시 청소도구(마포걸레 등)의 물기는 최대한 제거하고, 미끄럼주의 표지판을 설치하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 6,
                label: "청소용구 등 운반물 이동 시 전용대차를 사용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 7,
                label: "전기기계·기구 사용 시 방수형 콘센트를 사용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 8,
                label: "락스 등 유해·화학물질 사용 시 보호구(보안경, 보호장갑 등)을 착용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 9,
                label: "2m이상 고소작업시 안전난간대,발판,설치.안전대 착용등 떨어짐 예방 조치를 하였는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 10,
                label: "사다리 작업 시 안전한 작업 방법(안전대 착용, 2인 1조 작업, 전도방지용 안전지지대 설치 등)을 숙지하고 있는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 11,
                label: "중량물 취급 시 2인 1조 작업하거나 이동대차를 사용하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 12,
                label: "주기적으로 스트레칭을 실시하는가?",
                is_checked: "",
                note: ''
              },
              {
                id: 13,
                label: "보행중 · 작업 중 휴대전화 사용 금지를 이행하고 있는가?",
                is_checked: "",
                note: ''
              },
            ],
          },
        ]
      },
    };
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
